<template>
    <pm-app-component hide-sidebar>

        <template slot="mobile-toolbar">
            <pm-application-bar simple>
                Messages
            </pm-application-bar>
        </template>

        <div>
            <div v-if="messages.length === 0" style="text-align: center; display: flex; justify-content: center; align-items: center; height: Calc(100vh - 160px);">
                No new messages.<br/>Check back later.
            </div>

            <pm-message-item v-for="message in messages" :key="message.id" :message="message" />
        </div>
    </pm-app-component>
</template>

<script>
import ToolbarMixin from "../../extensions/mixins/mixin-toolbar";
import PmMessageItem from "./message-item";

import { getMessages, countUnreadMessages } from "@/configs/in-app-messages";

export default {
    name: "PmMessages",
    mixins: [
        ToolbarMixin,
    ],
    components: {
        PmMessageItem,
    },
    data: () => ({
        messages: getMessages(),
    }),
    toolbar() {
        const items = [];


            //  items.push({
            //      mdi: "mdiCommentProcessingOutline",
            //      text: "Contact us",
            //      callback: () => {
            //          this.$router.push("/feedback");
            //      },
            //  });

            items.push({ placeholder: true });

            items.push({ placeholder: true });

            items.push({ placeholder: true });

            items.push({
                back: true,
                callback: () => {
                    this.$router.push("/");
                },
            });


        return ([items]);
    },
    computed: {
        unread() {
            return countUnreadMessages();
        }
    },
    created() {

    },
    mounted() {
        // if (this.unread > 0) {
        //     try {
        //         const el = document.querySelector('.pm-message-item-unread');
        //         el.click();
        //     } catch (e) {
        //         window.captureException(e);
        //     }

        // }
    },
};
</script>
